<div class="datatable__pagination-content cv-grid-pagination-component">
	<div class="ag-theme-balham">
		<div class="ag-paging-panel">
			<span ref="eSummaryPanel" class="ag-paging-row-summary-panel">
				<span ref="lbFirstRowOnPage" class="item-currentValue">{{getFirstPageNumber()}}</span> to <span
					ref="lbLastRowOnPage" class="item-lastValue">{{getCurrentLimit()}}</span> of <span
					ref="lbRecordCount" class="item-totalValue">{{pagination.totalCount}}
				</span>
			</span>
			<span class="ag-paging-page-summary-panel">
				<div ref="btFirst" class="ag-paging-button" [ngClass]="{'ag-disabled': getCurrentPage() === FIRST_PAGE}">
					<span class="ag-icon ag-icon-first" unselectable="on"></span>
					<button type="button"
						class="action-goToFirst"
						[disabled]="getCurrentPage() === FIRST_PAGE"
						(click)="goToPage(pageActionType.FIRST)"
						(keydown)="onKeydown($event)"
						>
						First
					</button>
				</div>
				<div ref="btPrevious" class="ag-paging-button" [ngClass]="{'ag-disabled': (pagination.offset === 0)}">
					<span class="ag-icon ag-icon-previous" unselectable="on"></span>
					<button type="button"
						class="action-goToPrev"
						(click)="goToPage(pageActionType.PREVIOUS)"
						(keydown)="onKeydown($event)"
						>
						Previous
					</button>
				</div>

				Page <span ref="lbCurrent" class="item-currentValue">{{getCurrentPage()}}</span> of <span 
					ref="lbTotal" class="item-totalValue">{{getTotalPages()}}</span>

				<div ref="btNext" class="ag-paging-button" [ngClass]="{'ag-disabled': ((pagination.offset + pagination.limit) >= pagination.totalCount)}">
					<span class="ag-icon ag-icon-next" unselectable="on"></span>
					<button type="button" 
						class="action-gotToNext"
						(click)="goToPage(pageActionType.NEXT)"
						(keydown)="onKeydown($event)"
						>
						Next
					</button>
				</div>
				<div ref="btLast" class="ag-paging-button" [ngClass]="{'ag-disabled': !pagination.totalCount || getCurrentPage() === getTotalPages()}">
					<span class="ag-icon ag-icon-last" unselectable="on"></span>
					<button type="button" 
						class="action-goToLast"
						[disabled]="!pagination.totalCount" 
						(click)="goToPage(pageActionType.LAST)"
						(keydown)="onKeydown($event)"
						>
						Last
					</button>
				</div>
			</span>
		</div>
	</div>
</div>
